export const durations = {
  instant: 0.08,
  fast: 0.16,
  normal: 0.24,
  slow: 0.36,
  deliberate: 0.52,
} as const;

export const easings = {
  standard: [0.22, 1, 0.36, 1] as const,
  enter: [0.16, 1, 0.3, 1] as const,
  exit: [0.7, 0, 0.84, 0] as const,
  emphasized: [0.34, 1.56, 0.64, 1] as const,
} as const;

export const springs = {
  soft: {
    type: "spring" as const,
    stiffness: 260,
    damping: 28,
    mass: 0.8,
  },
  responsive: {
    type: "spring" as const,
    stiffness: 420,
    damping: 32,
    mass: 0.7,
  },
  gentle: {
    type: "spring" as const,
    stiffness: 180,
    damping: 24,
    mass: 1,
  },
} as const;

export const pageVariants = {
  enter: (direction: number) => ({
    x: direction > 0 ? 24 : -24,
    opacity: 0,
  }),
  center: {
    x: 0,
    opacity: 1,
  },
  exit: (direction: number) => ({
    x: direction > 0 ? -16 : 16,
    opacity: 0,
  }),
} as const;

export type DurationToken = keyof typeof durations;
export type EasingToken = keyof typeof easings;
export type SpringToken = keyof typeof springs;
